import React, { useEffect, useState } from "react";
import DemoInterestedSection from "../../Component/DemoInterestedSection";
import AboutBannerSection from "./component/AboutBannerSection";
import OurStorySection from "./component/OurStorySection";
import LeadershipSection from "./component/LeadershipSection";

function AboutUsPage() {
  const [acfData, setAcfData] = useState(null);
  const onRefresh = async () => {
    try {
      const response = await fetch(
        "https://www.lagunacreek.io/blog/wp-json/custom/v1/acf-data/about-us"
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const source = await response.json();
      const acf_fields = source?.acf_fields;
      setAcfData(acf_fields);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    onRefresh();
  }, []);
  return (
    <>
      <AboutBannerSection acfData={acfData} />
      <OurStorySection acfData={acfData} />
      <LeadershipSection acfData={acfData} />
      <DemoInterestedSection acfData={acfData} />
    </>
  );
}

export default AboutUsPage;
